"use client";
import React, { useEffect } from "react";
import { HiOutlineXMark } from "react-icons/hi2";
import { motion } from "framer-motion";
const BlogModal = ({ openModal, onClose, data }) => {
  // Prevent scrolling when modal is open
  useEffect(() => {
    document.body.style.overflow = openModal ? "hidden" : "unset";
    return () => (document.body.style.overflow = "unset");
  }, [openModal]);

  if (!openModal) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* BACKDROP */}
      <div
        className="absolute inset-0 bg-blue-950/5 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* MODAL */}
      <motion.div
        // initial={{ opacity: 0, scale: 0.9, y: 40 }}
        // animate={{ opacity: 1, scale: 1, y: 0 }}
        // exit={{ opacity: 0, scale: 0.9, y: 40 }}
        // transition={{ duration: 0.1, ease: "easeOut" }}
        className="relative w-full max-w-3xl bg-white/95 backdrop-blur-xl rounded-2xl shadow-2xl border border-gray-200 overflow-hidden"
      >
        {/* HEADER */}
        <div className="flex items-center justify-between px-6 py-5 border-b bg-gradient-to-r from-[#0f172a] to-[#1e293b] text-white">
          <h2 className="text-xl md:text-2xl font-semibold">
            {data?.title || "Blog Post"}
          </h2>
          <button
            onClick={onClose}
            className="p-2 rounded-full bg-white/10 hover:bg-white/50 transition"
          >
            <HiOutlineXMark size={22} />
          </button>
        </div>

        {/* BODY */}
        <div className="p-6 md:p-8 max-h-[65vh] overflow-y-auto text-zinc-200 bg-gray-700">
          {data?.category && (
            <span className="inline-block mb-4 px-3 py-1 text-xs font-semibold tracking-wide  rounded-full">
              {data.category}
            </span>
          )}

          <p className=" leading-relaxed text-base md:text-lg whitespace-pre-line text-justify">
            {data?.message}
          </p>
        </div>

        {/* FOOTER */}
        <div className="flex justify-end gap-3 px-6 py-4 border-t bg-gray-700">
          {/* <button
            onClick={onClose}
            className="px-5 py-2 text-sm font-medium rounded-lg border border-gray-300 hover:bg-gray-100 transition"
          >
            Close
          </button> */}

        </div>
      </motion.div>
    </div>

  );
};

export default BlogModal;